module.exports = __webpack_public_path__ + "img/fernandaramirez.f3aea8e4.jpg";